import { axios, Response } from '../index'

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
  DONT_WANT_TO_TELL = 'DONT_WANT_TO_TELL'
}

export type UpdatePersonaProfileBody = {
  avatar?: string
  avatarName: string
  firstName: string
  lastName?: string
  gender: Gender
  cpfOrPassport: string
  email: string
  zipCode: string
  address: string
  houseNumber: string
  city: string
  state: string
  complement: string
  countryCode: string
  ddd: string
  telephoneNumber: string
  login: string
}

type UpdatePersonaProfileResponse = Response<{
  id: string
  avatarName: string
  appUserId: number
  firstName: string
  lastName: string
  gender: Gender
  cpfOrPassport: string
  email: string
  zipCode: string
  address: string
  houseNumber: string
  city: string
  state: string
  complement: string
  countryCode: string
  ddd: string
  telephoneNumber: string
  avatar: string
  login: string
}>

const updatePersonaProfile = (
  personaId: string,
  body: UpdatePersonaProfileBody
): UpdatePersonaProfileResponse => {
  return axios.put(`/v1/profiles-personas/${personaId}`, body)
}

export default updatePersonaProfile
